<template>
  <div class="login d-flex align-items-center justify-content-center min-vh-100">
    <div class="login-container p-5 rounded shadow-lg">
      <h2 class="text-center mb-4">Welcome Back</h2>
      <p class="text-center text-muted mb-5">Please enter your details to log in</p>
      <form @submit.prevent="handleLogin">
        <div class="mb-4">
          <label for="email" class="form-label">Email address</label>
          <input 
            type="email" 
            class="form-control form-control-lg" 
            id="email" 
            v-model="email" 
            required 
            autofocus 
            placeholder="Enter your email"
          >
          <div v-if="emailError" class="text-danger">{{ emailError }}</div>
        </div>
        <div class="mb-4">
          <label for="password" class="form-label">Password</label>
          <input 
            type="password" 
            class="form-control form-control-lg" 
            id="password" 
            v-model="password" 
            required 
            placeholder="Enter your password"
          >
          <div v-if="passwordError" class="text-danger">{{ passwordError }}</div>
        </div>
        <button type="submit" class="btn btn-primary btn-lg w-100">Sign In</button>
      </form>
      <div class="text-center mt-4">
        <a href="#" @click.prevent="navigateToForgotPassword" class="text-muted">Forgot Password?</a>
      </div>

      <div v-if="loginError" class="text-danger text-center mt-3">{{ loginError }}</div>
    </div>
  </div>
</template>

<script>
import { AuthService } from '@/Services/AuthService';
import { useRouter } from 'vue-router'; // Import useRouter

export default {
  name: "LoginPage",
  data() {
    return {
      email: '',
      password: '',
      loginError: null,
      emailError: null,
      passwordError: null
    };
  },
  setup() {
    const router = useRouter(); // Get router instance

    // Check for auth token and redirect if it exists
    if (localStorage.getItem('authToken')) {
      router.push({ name: 'DashboardPage' }); // Redirect to DashboardPage if the token exists
    }

    return {
      router // Return it so you can use it in methods
    };
  },
  methods: {

    navigateToForgotPassword() {
      this.$router.push({ name: 'ForgotPassword' });
    },
    
    async handleLogin() {
      this.loginError = null; // Reset error message
      this.emailError = null; // Reset email error
      this.passwordError = null; // Reset password error

      // Basic validation
      if (!this.email) {
        this.emailError = "Email is required.";
        return;
      }
      if (!this.password) {
        this.passwordError = "Password is required.";
        return;
      }

      try {
        const response = await AuthService.login({ email: this.email, password: this.password });

        // Check if login was successful
        if (response.success) {
          console.log("Login successful:", response.data);
          localStorage.setItem('authToken', response.data.token); // Store the token
          // Optionally, you can store user details as well
          localStorage.setItem('user', JSON.stringify(response.user));
          this.router.push({ name: 'DashboardPage' }); // Navigate to DashboardPage on success
        } else {
          this.loginError = response.message || "Login failed. Please try again."; // Handle failure
        }
      } catch (error) {
        this.loginError = "Login failed. Please check your credentials and try again.";
        console.error("Login failed:", error);
      }
    }
  }
};
</script>

<style scoped>
.login-container {
  max-width: 400px;
  width: 100%;
  background-color: #fff;
}

.login {
  background-color: #f0f2f5;
}

h2 {
  font-weight: bold;
  color: #333;
}

.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
}

.btn-primary:hover {
  background-color: #0056b3;
  border-color: #0056b3;
}

.text-muted {
  color: #6c757d !important;
}

a.text-muted:hover {
  color: #333 !important;
}
.text-danger {
  color: red;
}
</style>
